import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as service from "../service/ScheduleService";
import { setIsLoading, setSubOrdinatesList, setSupervisorDetails } from "../slices/myteamSlice";

function useMyTeamSubordinate() {
    const dispatch = useDispatch();
    const isLoading = useSelector((state) => state.myteam.isLoading);
    const { currentCompany, currentEmployee } = useSelector((state) => state.company);

    const getSubOrdinates = useCallback(
        async () => {
            try {
                dispatch(setIsLoading(true));
                const response = await service.getSubOrdinates({
                    companyId: currentCompany,
                    employeeId: currentEmployee,
                });
                dispatch(setSubOrdinatesList(response?.data?.subOrdinateDetailsList || []));
                dispatch(setSupervisorDetails(response?.data?.supervisorDetails || {}));
            } catch (error) {
                console.log(error);
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, currentEmployee, dispatch]
    );

    useEffect(() => {
        if (currentCompany &&
            currentEmployee)
            getSubOrdinates();
    }, [currentCompany,
        currentEmployee]);

    return {
        isLoading
    }
}
export default useMyTeamSubordinate; 